import { Box, Center, Text } from '@chakra-ui/react';
import * as React from 'react';

import { GridImage } from './GridImage';

export const GridImagePlusMore: React.FC<{
  src: string | null;
  numOtherImages: number;
}> = ({ src, numOtherImages }) => {
  return (
    <Box
      width="100%"
      height="100%"
      position="relative"
      _hover={{ cursor: 'pointer' }}
    >
      <GridImage src={src || undefined} />
      <Center
        position="absolute"
        h="full"
        w="full"
        top={0}
        left={0}
        backgroundColor="blackAlpha.600"
      >
        <Text color="white" fontSize="lg" fontWeight="semibold">
          + {numOtherImages} more
        </Text>
      </Center>
    </Box>
  );
};
